module.exports = __webpack_public_path__ + "static/media/Bioexcel.9e7ef4d7.png";